const ITEMS = [
  "Business Consulting",
  "Healthcare Support",
  "Property Services",
  "Event Management",
  "Facility Services",
  "Housekeeping",
  "Security",
  "Administration",
  "Manpower",
];

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-gold/20 bg-navy-950 py-5"
    data-testid="services-marquee"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-serif text-xl italic tracking-wide text-white/75 sm:text-2xl">{item}</span>
              <span className="mx-8 inline-block h-2 w-2 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
